import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';

import { AppSidebarItem, AppSidebarItemProps } from 'features/app/components/AppSidebarItem';

import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down-icon.svg';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

type ListItem = {
  title: string;
  href: string;
};

interface AppSidebarItemWithListProps
  extends Omit<AppSidebarItemProps, 'hasNestedRoutes' | 'href' | 'bold' | 'onSidebarItemClick'> {
  listItems: ListItem[];
}

export const AppSidebarItemWithList: React.FC<AppSidebarItemWithListProps> = ({ title, icon, listItems }) => {
  const history = useHistory();
  const location = useLocation();

  const activeListItem = React.useMemo(
    () => listItems.find(listItem => listItem.href === location.pathname),
    [location, listItems]
  );

  /* The list is active if even one of his items href's matches a current location pathname. */
  const isListActive = React.useMemo(() => !!activeListItem, [activeListItem]);
  const [isListOpened, setIsListOpened] = React.useState(isListActive);
  const handleClickOnList = () => {
    setIsListOpened(!isListOpened);
  };
  const handleListItemClick = (href: string) => history.push(href);
  const direction = i18n.dir();

  const classes = useStyles({ isListOpened, isListActive, direction });

  return (
    <div className={classes.sidebarItemWithListRoot}>
      <AppSidebarItem
        href={activeListItem?.href}
        title={title}
        icon={icon}
        onSidebarItemClick={handleClickOnList}
        additionalClassName={classes.listItem}
      >
        <Box className={classes.arrowIconContainer}>
          <ArrowIcon />
        </Box>
      </AppSidebarItem>
      <Collapse in={isListOpened} timeout={0} unmountOnExit>
        <List component="div" disablePadding classes={{ root: classes.subListContainer }}>
          {listItems.map(listItem => (
            <ListItem
              key={listItem.href}
              classes={{ root: classes.listSubItem }}
              onClick={() => handleListItemClick(listItem.href)}
              button
            >
              <ListItemText primary={listItem.title} classes={{ primary: classes.subListItemText }} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </div>
  );
};
